export default "__VITE_ASSET__Dw5j339A__"